import { useMutation } from '@tanstack/react-query'
import React from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { useSearchParams } from 'react-router'
import { useMount } from 'react-use'

import useNotyf from '../../../hooks/useNotyf'
import { NylasRedirect } from '../../../lib/constants'
import apiService from '../../../lib/services/apiService'
import { INTEGRATION_SERVICE, IntegrationService } from '../../../types/misc'
import { SEARCH_PARAMS } from '../constants'

interface Props {
  nylasRedirect: NylasRedirect
}

interface State {
  service: IntegrationService
}

const AfterAuthentication: React.FC<Props> = ({ nylasRedirect }) => {
  const [searchParams] = useSearchParams()
  const code = searchParams.get(SEARCH_PARAMS.code)
  const stateJson = searchParams.get(SEARCH_PARAMS.state)
  const notyf = useNotyf()

  // Email gets a state, calendar doesn't, because we get here via the NylasScheduler
  const service: IntegrationService | null = stateJson
    ? (JSON.parse(stateJson) as State).service
    : null

  useMount(() => {
    swapTokenMutation.mutate()
  })

  function reloadPageWithoutPostAuthParamsAfterTimeout(error?: Error) {
    const params = new URLSearchParams(window.location.search)
    params.delete(SEARCH_PARAMS.code)
    params.delete(SEARCH_PARAMS.state)

    const isCalendarConnectionError =
      !!error && service === INTEGRATION_SERVICE.nylasCalendar

    if (isCalendarConnectionError) {
      params.set(SEARCH_PARAMS.calendarConnectionFailed, 'true')
    }

    setTimeout(() => {
      window.location.assign(`${window.location.pathname}?${params}`)
    }, 2000)
  }

  const swapTokenMutation = useMutation({
    mutationFn: async () =>
      apiService.post(`/v1/nylas/post-auth/${nylasRedirect}`, {
        code,
        service,
      }),
    onSuccess: () => {
      notyf.success('Account connected.')

      reloadPageWithoutPostAuthParamsAfterTimeout()
    },
    onError: (error) => {
      notyf.error('Authentication failed.')

      reloadPageWithoutPostAuthParamsAfterTimeout(error)
    },
  })

  return (
    <Modal show centered className="text-bg-light">
      <Modal.Body className="p-4 d-flex flex-column align-items-center gap-4">
        <div className="text-center">
          <h1>
            <strong>Finishing up</strong>
          </h1>

          <p>You will be redirected back to the RQ app in a moment.</p>
        </div>

        <Spinner variant="primary" animation="grow" />
      </Modal.Body>
    </Modal>
  )
}

export default AfterAuthentication
